import React, { Component } from "react";
import { Button, Modal, FormControl } from "react-bootstrap";


export default class OverridePartInfopopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            overrideReason: null           
        };
    }

    render() {

        return (
            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={false}
                onHide={this.props.onHide}
                show={this.props.show}
                pageText={this.props.pageText}
                size="md"
            >
                <Modal.Header>
                    <Modal.Title>
                        {this.props.pageText ? this.props.pageText.partInfoOverideHeaderText : "Put part on override (comments)"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col">
                                <FormControl
                                    as="textarea"                                    
                                    rows="4"
                                    onChange={(event) => {
                                        this.setState({ overrideReason : event.target.value})
                                    }}                                    
                                />
                                
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => this.props.handleOnOverideClick(this.state.overrideReason)}                                   
                        variant="btn btn-danger"
                    >
                        {this.props.pageText ? this.props.pageText.partInfoOverideSave : "Save"}
                    </Button>
                    <Button
                        onClick={this.props.onHide}
                        variant="btn btn btn-secondary"
                    >
                        {this.props.pageText ? this.props.pageText.partInfoOverideClose : "Cancel"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );

    }

}
